<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-xs-9">
        <h2>{{ event.name }}</h2>
        <p>Activity Location: {{ event.location }}</p>
        <p>
          Activity Time: {{ event.start_time | moment("YYYY-MM-DD HH:mm:ss") }} ~ {{ event.end_time | moment("YYYY-MM-DD HH:mm:ss") }}
        </p>
        <p>Activity Color: {{ event.color }}
          <span
                :style="{background: event.color}"
                style="padding: 7px;  text-align: center; margin-top: 20px; display: inline-block;"
                class="m-l-xs" />
        </p>
        <p>Activity Visibility:
          <i
             :class="{
              'text-navy fa-check': event.visibility,
              'fa-times': !event.visibility
            }"
             class="fa" />
        </p>
        <span
              class="nav-label"
              style="margin-right: 1rem;">Seats Available:</span>
        <span class="label label-warning">{{ event.total_seats - event.registered_count }}/{{ event.total_seats }}</span>
        <p style="margin-top: 1rem;">Activity Description: {{ event.description }}</p>
        <p>Activity Weekly Unique ID: {{ event.weekly_unique_id }}</p>
        <template v-if="isAdmin">
          <p>Forbidden Time Before Start: {{ event.forbid_minutes }} minutes</p>
        </template>
      </div>

      <div
           id="event_control"
           class="col-xs-3">
        <template v-if="isAdmin">
          <div class="row">
            <button
                    id="qrcode"
                    class="btn btn-md btn-primary d-block pull-right"
                    @click="downloadClick">
              <strong>Download Sign In QR Code
                <a id="downloadLink" />
              </strong>
            </button>
          </div>
          <div class="row">
            <button
                    class="btn btn-md btn-primary d-block pull-right"
                    @click="getPdf">
              <strong>Download PDF</strong>
            </button>
          </div>
          <div class="row">
            <button
                    class="btn btn-md btn-danger d-block pull-right"
                    data-toggle="modal"
                    data-target="#eventDeletionModal">
              <strong>Cancel Activity</strong>
            </button>
            <div
                 id="eventDeletionModal"
                 class="modal inmodal fade"
                 tabindex="-1"
                 role="dialog"
                 aria-labelledby="eventDeletionLabel"
                 aria-hidden="true">
              <div
                   class="modal-dialog"
                   role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Cancel Activity</h5>
                    <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <p>Are you sure you want to cancel this activity?</p>
                    <div
                         v-show="errorShow"
                         class="toast-top-right"
                         style="margin: 0 0 2%;">
                      <div
                           class="toast toast-error"
                           style="opacity: 0.69075;">
                        <div
                             class="toast-message"
                             style="padding: 1%; color: white; font-size: 1.5rem;">
                          This activity cannot be canceled: " {{ errorMessage }} "
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                            type="button"
                            class="btn btn-md btn-secondary"
                            data-dismiss="modal">No</button>
                    <button
                            id="eventDeletionBtn"
                            type="submit"
                            class="btn btn-md btn-danger"
                            @click="deleteActivity">Yes</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <button
                    class="btn btn-primary d-block pull-right"
                    type="button"
                    data-toggle="modal"
                    data-target="#editActivityModal">
              <i class="fa fa-paste fa-fw" /> <strong>Edit</strong>
            </button>
          </div>
        </template>
        <div class="row">
          <template v-if="!self_registered">
            <template v-if="!user.blacklist">
              <div id="event_control_user">
                <vue-ladda
                           :loading="isRegisterInProgress"
                           button-class="btn btn-md btn-primary d-block pull-right"
                           data-style="expand-right"
                           @click="enrollActivity">
                  <strong>Register</strong>
                </vue-ladda>
              </div>
            </template>
            <template v-else>
              <div id="event_control_user">
                <button
                        disabled
                        class="btn btn-md btn-primary d-block pull-right">
                  <strong>In Blacklist</strong>
                </button>
              </div>
            </template>
          </template>
          <template v-else>
            <div id="event_control_user">
              <button
                      disabled
                      class="btn btn-md btn-primary d-block pull-right">
                <strong>Registered</strong>
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div
         v-if="isAdmin"
         class="wrapper wrapper-content">
      <!-- <div class="row animated fadeInDown">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Search Registered Person</h5>
              <div class="ibox-tools">
                <a class="collapse-link">
                  <i class="fa fa-chevron-up"></i>
                </a>
              </div>
            </div>
            <div class="ibox-content">
              <div class="row">
                <div class="col-sm-3">
                  <div class="form-group">
                    <label class="control-label" for="name">Name</label>
                    <input type="text" id="name" name="name" value="" placeholder="Name" class="form-control">
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label class="control-label" for="id">Student/Work ID
                    </label>
                    <input type="text" id="id" name=id value="" placeholder="Student/Work ID" class="form-control">
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label class="control-label" for="status">Status</label>
                    <select name="status" id="status" class="form-control">
                      <option value="0">Not Show</option>
                      <option value="1" selected="">Signed</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label class="control-label"> </label>
                    <button class="btn btn-primary" style="width: 100%; margin-top: 2.2rem;">Search</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="row animated fadeInDown">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Search Signed User</h5>
              <div class="ibox-tools">
                <a class="collapse-link">
                  <i class="fa fa-chevron-up" />
                </a>
              </div>
            </div>
            <div class="ibox-content">
              <div class="ibox-content">
                <div class="row">
                  <div class="form-inline">
                    <div class="form-group m-r-md">
                      <input
                             v-model="searchInputName"
                             type="text"
                             placeholder="Name"
                             class="form-control">
                    </div>
                    <div class="form-group">
                      <input
                             v-model="searchInputId"
                             type="text"
                             placeholder="School/Work Id"
                             class="form-control">
                    </div>
                    <div class="checkbox m-l-md m-r-md">
                      <input
                             id="searchIsAdmin"
                             v-model="searchIsAdmin"
                             type="checkbox">
                      <label for="searchIsAdmin">
                        Admin
                      </label>
                    </div>
                    <button
                            class="btn btn-primary"
                            @click="searchSignedUser()">Search</button>
                    <button
                            class="btn btn-primary m-l-md"
                            @click="searchReset()">Reset</button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <p>You don’t need to fill in all boxes.</p>
                  </div>
                </div>
                <div
                     v-if="searchResultShow"
                     class="row animated fadeInDown">
                  <div class="col-ld-12">
                    <vuetable
                              ref="vuetable"
                              :fields="fields"
                              :data="searchResult"
                              :css="tablecss"
                              :api-mode="false"
                              @vuetable:cell-clicked="onCellClicked" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row animated fadeInDown">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Registration List (Total: {{ registrations.length }})</h5>
              <div class="ibox-tools">
                <button
                        class="btn btn-primary btn-xs"
                        @click="downloadRegList">Download as Excel</button>
              </div>
            </div>
            <div class="ibox-content">
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th id="name">Name</th>
                      <th id="id">Student/Work ID</th>
                      <th id="time">Registration Time</th>
                      <th id="status">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                        v-for="reg in registrations"
                        :key="reg.id">
                      <td>{{ reg.user.name }}</td>
                      <td>{{ reg.user.ldap_id }}</td>
                      <td>{{ reg.order_time | moment("YYYY-MM-DD HH:mm:ss") }}</td>
                      <td>
                        <i
                           :class="{
                            'text-navy fa-check': reg.sign_in_status,
                            'text-warning': !reg.sign_in_status,
                            'fa-times': reg.order_status != 0 && reg.order_status != 1,
                            'fa-question': !reg.sign_in_status && reg.order_status == 0,
                            'fa-clock-o': reg.order_status === 1}"
                           class="fa" />
                      </td>
                      <td class="pull-right">
                        <button
                                v-if="!reg.sign_in_status && reg.order_status in [0, 1]"
                                type="submit"
                                class="btn btn-xs btn-danger"
                                @click="deleteRegistration(reg.id)">
                          Cancel
                        </button>
                        <button
                                v-if="!reg.sign_in_status && reg.order_status == 0"
                                type="submit"
                                class="btn btn-xs btn-primary"
                                @click="signInRegistration(reg.id)">
                          Sign In
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="ibox-footer">
              <i class="fa text-navy fa-check" />: Signed In,
              <i class="fa text-warning fa-times" />: Cancelled,
              <i class="fa text-warning fa-question" />: Not Signed In Yet
              <i class="fa text-warning fa-clock-o" />: In Waiting List
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
         id="regDeletionModal"
         class="modal inmodal fade"
         tabindex="-1"
         role="dialog"
         aria-labelledby="regDeletionLabel"
         aria-hidden="true">
      <div
           class="modal-dialog"
           role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Registration Deletion
            </h5>
            <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to delete this person from the registration list?</p>
            <p>It means that this person will be mark as non-registered.</p>
            <div
                 v-show="errorShow"
                 class="toast-top-right"
                 style="margin: 0 0 2%;">
              <div
                   class="toast toast-error"
                   style="opacity: 0.69075;">
                <div
                     class="toast-message"
                     style="padding: 1%; color: white; font-size: 1.5rem;">
                  This registration record cannot be deleted: " {{ errorMessage }} "
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
                    type="button"
                    class="btn btn-md btn-secondary"
                    data-dismiss="modal">No</button>
            <button
                    id="regDeletionBtn"
                    type="submit"
                    class="btn btn-md btn-danger"
                    @click="confirmDeleteRegistration">Yes</button>
          </div>
        </div>
      </div>
    </div>

    <div
         id="regAddModal"
         class="modal inmodal fade"
         tabindex="-1"
         role="dialog"
         aria-labelledby="regAddLabel"
         aria-hidden="true">
      <div
           class="modal-dialog"
           role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Manual Add User To Activity
            </h5>
            <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to manually sign this in?</p>
            <p>Name: {{ currentAddRegistrationName }}</p>
            <p>School/Work ID: {{ currentAddRegistrationLdapId }}</p>
            <div
                 v-show="errorShow"
                 class="toast-top-right"
                 style="margin: 0 0 2%;">
              <div
                   class="toast toast-error"
                   style="opacity: 0.69075;">
                <div
                     class="toast-message"
                     style="padding: 1%; color: white; font-size: 1.5rem;">
                  This user cannot be signed in: " {{ errorMessage }} "
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
                    type="button"
                    class="btn btn-md btn-secondary"
                    data-dismiss="modal">No</button>
            <button
                    id="regAddBtn"
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="confirmAddRegistration">Yes</button>
          </div>
        </div>
      </div>
    </div>
    <div
         id="regSignInModal"
         class="modal inmodal fade"
         tabindex="-1"
         role="dialog"
         aria-labelledby="regSignInLabel"
         aria-hidden="true">
      <div
           class="modal-dialog"
           role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Manual Sign In
            </h5>
            <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to manually sign this user in?</p>
            <div
                 v-show="errorShow"
                 class="toast-top-right"
                 style="margin: 0 0 2%;">
              <div
                   class="toast toast-error"
                   style="opacity: 0.69075;">
                <div
                     class="toast-message"
                     style="padding: 1%; color: white; font-size: 1.5rem;">
                  This user cannot be signed in: " {{ errorMessage }} "
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
                    type="button"
                    class="btn btn-md btn-secondary"
                    data-dismiss="modal">No</button>
            <button
                    id="regSignInBtn"
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="confirmSignInRegistration">Yes</button>
          </div>
        </div>
      </div>
    </div>

    <div
         id="editActivityModal"
         class="modal inmodal fade"
         tabindex="-1"
         role="dialog"
         aria-labelledby="editActivityLabel"
         aria-hidden="true">
      <div
           class="modal-dialog"
           role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Activity Modification</h5>
            <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form role="form">
              <div class="form-group">
                <label>Name</label>
                <input
                       v-model.trim="newActivity.name"
                       type="name"
                       placeholder="Enter activity name"
                       class="form-control">
              </div>
              <div class="form-group">
                <label>Description</label>
                <input
                       v-model.trim="newActivity.description"
                       type="description"
                       placeholder="Enter activity description"
                       class="form-control">
              </div>
              <div class="form-group">
                <label>Time</label>
                <div class="input-daterange input-group">
                  <span class="input-group-addon">
                    <span class="glyphicon glyphicon-time" />
                  </span>
                  <input
                         id="timespan"
                         type="text"
                         class="input-sm form-control"
                         name="timespan"
                         required>
                </div>
              </div>
              <div class="form-group">
                <label>Available Seats</label>
                <input
                       v-model.trim.number="newActivity.total_seats"
                       type="number"
                       min="0"
                       step="1"
                       placeholder="Enter the number of seats available"
                       class="form-control">
              </div>
              <div class="form-group">
                <label>Weekly Unique ID (Forbid user from enrolling events in the same value)</label>
                <div class="input-daterange input-group">
                  <input
                         v-model.trim.number="newActivity.weekly_unique_id"
                         type="text"
                         class="input-sm form-control"
                         name="weekly_unique_num"
                         required>
                </div>
              </div>
              <div class="form-group">
                <label>Forbidden Time Before Start (in Minute)</label>
                <input
                       v-model.trim="newActivity.forbid_minutes"
                       type="text"
                       placeholder="Enter the time"
                       class="input-sm form-control">
              </div>
              <div class="form-group">
                <label>Location</label>
                <input
                       v-model.trim="newActivity.location"
                       type="text"
                       placeholder="Enter the location"
                       class="form-control">
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Color</label>
                    <span
                          :style="{background: chosenColor}"
                          style="padding: 7px;  text-align: center; margin-top: 20px; display: inline-block;"
                          class="m-l-md" />
                    <div class="btn-group m-l-md">
                      <button
                              data-toggle="dropdown"
                              class="btn btn-default dropdown-toggle"> {{ chosenColor }}</button>
                      <ul class="dropdown-menu">
                        <chrome-picker
                                       id="colorpicker"
                                       :value="chosenColor"
                                       class="m-t-xs"
                                       @input="updateColor" />
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="">
                    <label> <input
                             v-model="newActivity.visibility"
                             type="checkbox"> Visibility </label>
                  </div>
                </div>
              </div>

            </form>
            <div
                 v-show="errorShow"
                 class="toast-top-right"
                 style="margin: 0 0 2%;">
              <div
                   class="toast toast-error"
                   style="opacity: 0.69075;">
                <div
                     class="toast-message"
                     style="padding: 1%; color: white; font-size: 1.5rem;">
                  This activity cannot be modified: " {{ errorMessage }} "
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
                    type="button"
                    class="btn btn-md btn-secondary"
                    data-dismiss="modal">Cancel</button>
            <button
                    id="editActivityBtn"
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="updateActivity()">Update</button>
          </div>
        </div>
      </div>
    </div>

    <div
         v-show="isPrint"
         id="pdfWrap"
         class="row wrapper white-bg page-heading">
      <div
           class="col-xs-9"
           style="margin-bottom: 10px;">
        <h1>{{ event.name }}</h1>
        <h3>Activity location: {{ event.location }}</h3>
        <h3>
          Activity time: {{ event.start_time | moment("YYYY-MM-DD HH:mm:ss") }} ~ {{ event.end_time | moment("YYYY-MM-DD HH:mm:ss") }}
        </h3>
        <h3>Seats available: {{ event.total_seats - event.registered_count }}/{{ event.total_seats }}
        </h3>
        <h3>Activity Weekly Unique ID: {{ event.weekly_unique_id }}</h3>
        <h4>Activity description: {{ event.description }}</h4>
        <template v-if="isAdmin">
          <h4>Forbidden Time Before Start: {{ event.forbid_minutes }} minutes</h4>
        </template>
      </div>
      <div
           id="qrcodeContainer"
           class="col-xs-3"
           style="padding: 5%;" />
      <div class="row wrapper white-bg page-heading">
        <div class="col-xs-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Registration List (Total: {{ registrations.length }})</h5>
            </div>
            <div class="ibox-content">
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th id="name">Name</th>
                      <th id="id">Student/Work ID</th>
                      <th id="status">Status</th>
                    </tr>
                  </thead>
                  <tbody id="user_list" />
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QRCode } from "@/utils/qrcode.js";
import XLSX from "xlsx";
import Vuetable from "vuetable-2/src/components/Vuetable";
import Vue from "vue";
import VueActivitys from "vue-events";
import html2canvas from "html2canvas";
import JSPDF from "jspdf";
import { Chrome } from "vue-color";
import VueLadda from "@/components/vue-ladda.vue";

Vue.use(VueActivitys);

export default {
  name: "EventsInfo",
  components: {
    Vuetable,
    // VuetablePagination,
    // VuetablePaginationInfo,
    vueevents: VueActivitys,
    "chrome-picker": Chrome,
    "vue-ladda": VueLadda
  },
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      event: {
        name: "Activity Name",
        description: "Activity Description",
        startTime: Date.now() / 1000,
        endTime: Date.now() / 1000,
        total_seats: 0,
        registered_count: 0,
        color: "#1AB394",
        weekly_unique_id: 0,
        forbid_minutes: 0
      },
      registrations: [],
      newActivity: {},
      self_registered: false,
      currentSignInRegistration: 0,
      currentAddRegistrationId: 0,
      currentAddRegistrationLdapId: "",
      currentAddRegistrationName: "",
      currentDeletingRegistration: 0,
      outFile: "",
      fields: [
        "No",
        {
          name: "name"
        },
        {
          name: "id"
        },
        {
          name: "User Type"
        },
        "Add User"
      ],
      tablecss: {
        tableClass:
          "table table-responsive table-striped table-bordered table-hover signed-users-list",
        titleClass: "title-class"
      },
      usersInfo: [],
      // formatUsersInfo: {},
      searchInputName: "",
      searchInputId: "",
      searchIsAdmin: false,
      searchResult: [],
      searchResultShow: false,
      chosenColor: "",
      isPrint: false,
      isRegisterInProgress: false,
      errorMessage: "",
      errorShow: false
    };
  },
  computed: {
    isAdmin () {
      if (this.user.roles) {
        const len = this.user.roles.length;
        for (let j = 0; j < len; j += 1) {
          if (this.user.roles[j] === "Admin") {
            return true;
          }
        }
      }
      return false;
    }
  },
  mounted () {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.fetchData();
    this.outFile = document.createElement("a");
    $('.i-checks').iCheck({
      checkboxClass: 'icheckbox_square-green',
      radioClass: 'iradio_square-green',
    }).on('ifChecked ifUnchecked', function () {
      $(this)[0].dispatchEvent(new Event("change"));
    });
  },
  methods: {
    updateColor (value) {
      this.chosenColor = value["hex"];
    },
    checkSearchInput () {
      if (this.searchInputName.trim() === "") {
        if (this.searchInputId.trim() === "") {
          if (!this.searchIsAdmin) {
            return 0; // All are empty
          } else {
            return 1; // Only type is filled
          }
        } else {
          if (!this.searchIsAdmin) {
            return 2; // Only Id is filled
          } else {
            return 3; // Id and Type are filled
          }
        }
      } else {
        if (this.searchInputId.trim() === "") {
          if (!this.searchIsAdmin) {
            return 4; // Only Name is filled
          } else {
            return 5; // Name and Type are filled
          }
        } else {
          if (!this.searchIsAdmin) {
            return 6; // ID and Name are filled
          } else {
            return 7; // All are filled
          }
        }
      }
    },
    checkRoles (value) {
      if (value.length !== 0) {
        if (value[0] === "Admin") {
          return "Admin";
        } else {
          return "";
        }
      }
    },
    transform (data) {
      const that = this;
      let transformed = {};
      transformed.data = [];
      for (var i = 0; i < data.length; i++) {
        transformed.data.push({
          No: data[i].id,
          name: data[i].name,
          id: data[i].ldap_id,
          "User Type": that.checkRoles(data[i].roles),
          "Add User": `<button type="submit" class="btn btn-xs btn-danger"
                           data-toggle="modal" data-target="#regAddModal">Add to Activity</button>`
        });
      }
      // console.log(transformed.data);
      return transformed;
    },
    fetchData () {
      const that = this;
      this.$emit("showLoading");
      if (this.user) {
        window.request
          .get(`event/${this.$route.params.id}`)
          .then(response => {
            that.event = response.data;
            that.event.color = that.event.color || "#1AB394";
            that.newActivity = Object.assign({}, that.event);
            that.popoverQRCode();

            $("#timespan").daterangepicker(
              {
                showDropdowns: true,
                timePicker: true,
                timePicker24Hour: true,
                autoApply: true,
                locale: {
                  format: "M/DD hh:mm A"
                },
                minDate: moment.min(
                  moment(),
                  moment.unix(that.event.start_time)
                ),
                startDate: moment.unix(that.event.start_time),
                endDate: moment.unix(that.event.end_time)
              },
              function (start, end, label) {
                that.newActivity.start_time = start.unix();
                that.newActivity.end_time = end.unix();
              }
            );
            if (that.isAdmin) that.fetchRegistrationInfo();
            $('.i-checks').iCheck('update');
          })
          .catch(error => {
            toastr.error(error);
            if (that.isAdmin) {
              that.$router.push("/manage/activity");
            } else {
              that.$router.push("/");
            }
          })
          .finally(() => {
            that.$emit("hideLoading");
            that.chosenColor = that.event.color;
          });
      }
    },
    fetchRegistrationInfo () {
      const that = this;
      this.$emit("showLoading");
      window.request
        .get(`event/${this.event.id}/registration`)
        .then(response => {
          that.registrations = response.data.registrations;
          if (that.isAdmin) that.fetchAllUsersData();
        })
        .catch(error => {
          toastr.error(error.response.data.message);
        })
        .finally(() => {
          this.$emit("hideLoading");
        });
    },
    fetchAllUsersData () {
      const that = this;
      this.$emit("showLoading");
      if (this.user) {
        window.request
          .get(`user/`)
          .then(response => {
            that.usersInfo = response.data.users;
            that.fetchUserRegistrationInfo();
          })
          .catch(error => {
            toastr.error(error.data.message);
          })
          .finally(() => {
            that.$emit("hideLoading");
          });
      }
    },
    fetchUserRegistrationInfo () {
      const that = this;
      this.$emit("showLoading");
      window.request
        .get(`user/${this.user.id}/registration/${this.event.id}`)
        .then(response => {
          that.self_registered = response.data.status;
        })
        .catch(error => {
          toastr.error(error.response.data.message);
        })
        .finally(() => {
          that.$emit("hideLoading");
        });
    },
    searchReset () {
      this.searchInputName = "";
      this.searchInputId = "";
      this.searchIsAdmin = false;
      this.searchResult = [];
      this.searchResultShow = false;
    },
    searchSignedUser () {
      let targetArray = [];
      let searchInputNameRegExp = RegExp(this.searchInputName.toLowerCase());
      let searchInputIdRegExp = RegExp(this.searchInputId);
      switch (this.checkSearchInput()) {
        case 0:
          this.searchResult = this.usersInfo;
          break;
        case 1:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (this.checkRoles(this.usersInfo[i].roles) === "Admin") {
              targetArray.push(this.usersInfo[i]);
            }
          }
          break;
        case 2:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (searchInputIdRegExp.test(this.usersInfo[i].ldap_id)) {
              targetArray.push(this.usersInfo[i]);
            }
          }
          break;
        case 3:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (searchInputIdRegExp.test(this.usersInfo[i].ldap_id)) {
              if (this.checkRoles(this.usersInfo[i].roles) === "Admin") {
                targetArray.push(this.usersInfo[i]);
              }
            }
          }
          break;
        case 4:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (
              searchInputNameRegExp.test(this.usersInfo[i].name.toLowerCase())
            ) {
              targetArray.push(this.usersInfo[i]);
            }
          }
          break;
        case 5:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (
              searchInputNameRegExp.test(this.usersInfo[i].name.toLowerCase())
            ) {
              if (this.checkRoles(this.usersInfo[i].roles) === "Admin") {
                targetArray.push(this.usersInfo[i]);
              }
            }
          }
          break;
        case 6:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (
              searchInputNameRegExp.test(this.usersInfo[i].name.toLowerCase())
            ) {
              if (searchInputIdRegExp.test(this.usersInfo[i].ldap_id)) {
                targetArray.push(this.usersInfo[i]);
              }
            }
          }
          break;
        case 7:
          for (var i = 0; i < this.usersInfo.length; i++) {
            if (
              searchInputNameRegExp.test(this.usersInfo[i].name.toLowerCase())
            ) {
              if (searchInputIdRegExp.test(this.usersInfo[i].ldap_id)) {
                if (this.checkRoles(this.usersInfo[i].roles) === "Admin") {
                  targetArray.push(this.usersInfo[i]);
                }
              }
            }
          }
          break;
      }
      if (targetArray.length === 0) {
        toastr.error("There is no match result!");
      } else {
        this.searchResult = this.transform(targetArray);
      }
      // console.log('transformed', this.searchResult);
      this.searchResultShow = true;
    },
    onCellClicked (data, field, event) {
      if (field.name === "Add User") {
        this.currentAddRegistrationName = data.name;
        this.currentAddRegistrationLdapId = data.id;
        this.currentAddRegistrationId = parseInt(data.No);
      }
    },
    checkEventValidation (event) {
      // check empty
      if (!event.name) {
        return "Please input an activity name!";
      }
      if (!event.description) {
        return "Please input an activity description!";
      }
      if (!event.location) {
        return "Please input an activity location!";
      }
      // check validation
      //check times
      const nowTime = Date.now() / 1000;
      if (event.start_time < nowTime || event.end_time < nowTime) {
        return "Please select a future time!";
      }
      if (event.start_time >= event.end_time) {
        return "End time should be later than start time!";
      }
      if (moment(event.start_time * 1000).hour() < 9) {
        return "Start time should not be earlier than 9am!";
      }
      if (
        moment(event.end_time * 1000).hour() >= 18 &&
        moment(event.end_time * 1000).minute() >= 1
      ) {
        return "End time should not be later than 18am!";
      }
      //check seats
      let reg = /[^0-9]/;
      if (reg.test(event.total_seats) || event.total_seats <= 0) {
        return "Please input a correct seats number!";
      }
      return 0;
    },
    updateActivity () {
      $("#editActivityBtn").button("loading");
      const that = this;
      this.errorShow = false;
      this.errorMessage = this.checkEventValidation(this.newActivity);
      if (this.errorMessage != 0) {
        setTimeout(function () {
          that.errorShow = true;
        }, 500);
        $("#editActivityBtn").button("reset");
        return;
      }
      this.request
        .post(`event/${this.event.id}`, {
          name: this.newActivity.name,
          description: this.newActivity.description,
          // date: this.eventDate,
          start_time: this.newActivity.start_time,
          end_time: this.newActivity.end_time,
          total_seats: this.newActivity.total_seats,
          location: this.newActivity.location,
          color: that.chosenColor,
          visibility: this.newActivity.visibility,
          forbid_minutes: this.newActivity.forbid_minutes
        })
        .then(response => {
          that.errorMessage = "";
          that.errorShow = false;
          that.event = Object.assign({}, that.newActivity);
          toastr.success("You have successfully update the activity!");
          that.fetchData();
          setTimeout(function () {
            $("#editActivityModal").modal("hide");
            console.log("event modification success");
            $("#editActivityBtn").button("reset");
          }, 500);
        })
        .catch(error => {
          that.errorShow = true;
          that.errorMessage =
            error.response.data.message || error.response.data.error;
          setTimeout(function () {
            that.errorMessage = that.errorMessage || "Server error";
          }, 500);
          $("#editActivityBtn").button("reset");
        })
        .finally(() => (that.chosenColor = "#1AB394"));
    },
    deleteActivity () {
      $("#eventDeletionBtn").button("loading");
      const that = this;
      this.request
        .delete(`event/${this.event.id}`)
        .then(response => {
          that.errorMessage = "";
          that.errorShow = false;
          that.$router.push({ name: "event-management" });
          setTimeout(function () {
            console.log("event deletion success");
            $("#eventDeletionBtn").button("reset");
          }, 500);
          $("#eventDeletionModal").modal("hide");
        })
        .catch(error => {
          that.errorShow = true;
          that.errorMessage =
            error.response.data.message || error.response.data.error;
          setTimeout(function () {
            that.errorMessage = that.errorMessage || "Server error";
          }, 500);
          $("#eventDeletionBtn").button("reset");
        });
    },
    popoverQRCode () {
      const $ = window.jQuery;
      const that = this;
      $("#qrcode")
        .popover({
          html: "true",
          // 本来这里是打算用funciton提供已生成二维码的DIV，结果获取不到生成的二维码
          content:
            '<div id="qrcodeContainer" style="width: 160px; height: 160px;"></div>',
          animation: false,
          placement: "left"
        })
        .on("mouseenter", function () {
          var self = this;
          $(this).popover("show");
          // 只有show之后，popover的content才出现在dom中，此时才能生成二维码
          var qrcode = new QRCode(document.getElementById("qrcodeContainer"), {
            text: `https://weixiao.cuhk.edu.cn/qrcode/sall?id=${
              that.event.id
              }&token=${that.event.signin_token}`,
            width: 150, //生成的二维码的宽度
            height: 150, //生成的二维码的高度
            colorDark: "#000000", // 生成的二维码的深色部分
            colorLight: "#ffffff" //生成二维码的浅色部分
          });

          $(this)
            .siblings(".popover")
            .on("mouseleave", function () {
              $(self).popover("hide");
            });
        })
        .on("mouseleave", function () {
          var self = this;
          setTimeout(function () {
            if (!$(".popover:hover").length) {
              $(self).popover("hide");
            }
          }, 100);
        });
    },
    downloadClick () {
      // 获取base64的图片节点
      const img = document
        .getElementById("qrcodeContainer")
        .getElementsByTagName("img")[0];
      // 构建画布
      const canvas = document.createElement("canvas");
      canvas.width = img.width + 20;
      canvas.height = img.height + 20;
      const context = canvas.getContext("2d");
      context.fillStyle = "white";
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(img, 10, 10);
      const url = canvas.toDataURL("image/png");
      const downloadLink = document.getElementById("downloadLink");
      downloadLink.setAttribute("href", url);
      downloadLink.setAttribute("download", "qrcode.png");
      downloadLink.click();
    },
    enrollActivity () {
      if (!this.isRegisterInProgress) {
        this.isRegisterInProgress = true;
        const that = this;
        this.request
          .post(`event/${this.event.id}/registration`, {
            id: that.user.id
          })
          .then(function (response) {
            toastr.success("Successfully enrolled.");
            that.fetchUserRegistrationInfo();
            that.fetchData();
            // eslint-disable-next-line
          })
          .catch(function (error) {
            toastr.error(error.response.data.message);
          })
          .finally(() => {
            that.isRegisterInProgress = false;
          });
      }
    },
    deleteRegistration (id) {
      this.errorShow = false
      this.errorMessage = ""
      $("#regDeletionModal").modal("show");
      this.currentDeletingRegistration = id;
    },
    confirmDeleteRegistration () {
      $("#regDeletionBtn").button("loading");
      const that = this;
      this.request
        .delete(`registration/${this.currentDeletingRegistration}`)
        .then(response => {
          // console.log(this.registrations);
          that.errorMessage = "";
          that.errorShow = false;
          console.log(this.currentDeletingRegistration);
          toastr.success("Successfully deleted the registration.");
          that.fetchRegistrationInfo();
          setTimeout(function () {
            $("#regDeletionModal").modal("hide");
            console.log("registration deletion success");
            // stop loading
            $("#regDeletionBtn").button("reset");
          }, 500);
        })
        .catch(error => {
          that.errorShow = true;
          that.errorMessage =
            error.response.data.message || error.response.data.error;
          setTimeout(function () {
            that.errorMessage = that.errorMessage || "Server error";
          }, 500);
          $("#regDeletionBtn").button("reset");
        });
    },
    signInRegistration (id) {
      this.errorShow = false
      this.errorMessage = ""
      $("#regSignInModal").modal("show");
      this.currentSignInRegistration = parseInt(id);
    },
    confirmSignInRegistration () {
      $("#regSignInBtn").button("loading");
      const that = this;
      this.request
        .post(`registration/${this.currentSignInRegistration}`, {
          sign_in_status: 1
        })
        .then(response => {
          that.errorMessage = "";
          that.errorShow = false;
          toastr.success("Successfully sign in the registration.");
          that.fetchRegistrationInfo();
          setTimeout(function () {
            $("#regSignInModal").modal("hide");
            console.log("user successfully signed in");
            $("#regSignInBtn").button("reset");
          }, 500);
        })
        .catch(error => {
          that.errorShow = true;
          that.errorMessage =
            error.response.data.message || error.response.data.error;
          setTimeout(function () {
            that.errorMessage = that.errorMessage || "Server error";
          }, 500);
          $("#regSignInBtn").button("reset");
        });
    },
    confirmAddRegistration () {
      $("#regAddBtn").button("loading");
      const that = this;
      console.log(this.currentAddRegistrationId);
      this.request
        .post(`event/${this.$route.params.id}/registration`, {
          id: this.currentAddRegistrationId
        })
        .then(response => {
          that.errorMessage = "";
          that.errorShow = false;
          that.fetchRegistrationInfo();
          setTimeout(function () {
            $("#regAddModal").modal("hide");
            console.log("registration successfully added");
            $("#regAddBtn").button("reset");
          }, 500);
        })
        .catch(error => {
          that.errorShow = true;
          that.errorMessage =
            error.response.data.message || error.response.data.error;
          setTimeout(function () {
            that.errorMessage = that.errorMessage || "Server error";
          }, 500);
          $("#regAddaBtn").button("reset");
        });
    },
    downloadRegList () {
      //导出按钮
      const that = this;
      let tempData = [];
      let currentStatus = "unknown";
      let date = "";
      for (let k in that.registrations) {
        if (that.registrations[k].order_status == 0) {
          currentStatus = "Registered";
        } else if (that.registrations[k].order_status == 1) {
          currentStatus = "Waiting List";
        } else if (that.registrations[k].order_status == 2) {
          currentStatus = "Cancelled by User";
        } else if (that.registrations[k].order_status == 3) {
          currentStatus = "Cancelled due to Blacklist";
        }

        if (that.registrations[k].sign_in_status) {
          currentStatus = "Checked In";
        }

        // if (
        //   !that.registrations[k].sign_in_status &&
        //   that.registrations[k].cancel_status == 0
        // ) {
        //   currentStatus = "unknown";
        // }
        if (that.registrations[k].order_time != "") {
          date = new Date();
          date.setTime(that.registrations[k].order_time * 1000);
          date = date.toLocaleString();
        }
        tempData.push({
          ID: that.registrations[k].id,
          "Name": that.registrations[k].user.name,
          "Student ID": that.registrations[k].user.ldap_id,
          "Student Email": that.registrations[k].user.email,
          "Registration Time": date,
          "status": currentStatus
        });
      }
      this.downloadExl(tempData, that.event.name + "_Registration List");
    },
    downloadExl (data, downName) {
      var workbook = XLSX.utils.book_new();

      var ws = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(workbook, ws, "Results");
      XLSX.writeFile(workbook, downName + '.xlsx', { type: 'file' });
    },
    s2ab (s) {
      // 字符串转字符流
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buf;
    },
    getPdf () {
      let _this = this;
      _this.isPrint = true;
      let currentStatus = "unknown";
      let startTime = "";
      let endTime = "";
      document.getElementById("user_list").innerHTML = "";
      document.getElementById("qrcodeContainer").innerHTML = "";
      // 加入registration list
      for (let k in _this.registrations) {
        if (_this.registrations[k].order_status == 0) {
          currentStatus = "Registered";
        } else if (_this.registrations[k].order_status == 1) {
          currentStatus = "Waiting List";
        } else if (_this.registrations[k].order_status == 2) {
          currentStatus = "Cancelled by User";
        } else if (_this.registrations[k].order_status == 3) {
          currentStatus = "Cancelled due to Blacklist";
        }

        if (_this.registrations[k].sign_in_status) {
          currentStatus = "Checked In";
        }
        document.getElementById("user_list").innerHTML +=
          "   <tr>\n" +
          "     <td>" +
          _this.registrations[k].user.name +
          "</td>\n" +
          "       <td>" +
          _this.registrations[k].user.ldap_id +
          "</td>\n" +
          "       <td>\n" +
          currentStatus +
          "</td>\n" +
          "   </tr>\n";
      }
      // 加入二维码
      var qrcode = new QRCode(document.getElementById("qrcodeContainer"), {
        text: `https://weixiao.cuhk.edu.cn/qrcode/sall?id=${
          _this.event.id
          }&token=${_this.event.signin_token}`,
        width: 100, //生成的二维码的宽度
        height: 100, //生成的二维码的高度
        colorDark: "#000000", // 生成的二维码的深色部分
        colorLight: "#ffffff" //生成二维码的浅色部分
      });
      _this.$nextTick(function () {
        let pdfDom = document.querySelector("#pdfWrap");
        html2canvas(pdfDom, {
          allowTaint: true
        }).then(function (canvas) {
          let size = [595.28, 841.89];
          let position = 30;
          let WGUTTER = 30;
          let contentWidth = canvas.width;
          let contentHeight = canvas.height;
          let pageHeight = (contentWidth / size[0]) * size[1];
          let leftHeight = contentHeight;
          let imgWidth = size[0] - WGUTTER * 2;
          let imgHeight = (imgWidth / contentWidth) * contentHeight;
          let pageData = canvas.toDataURL("image/jpeg", 1.0);
          let PDF = new JSPDF("", "pt", "a4");
          if (leftHeight < pageHeight) {
            PDF.addImage(
              pageData,
              "JPEG",
              WGUTTER,
              position,
              imgWidth,
              imgHeight
            );
          } else {
            while (leftHeight > 0) {
              PDF.addImage(
                pageData,
                "JPEG",
                WGUTTER,
                position,
                imgWidth,
                imgHeight
              );
              leftHeight -= pageHeight;
              position -= 841.89;
              if (leftHeight > 0) {
                PDF.addPage();
              }
            }
          }
          PDF.save(_this.event.name + ".pdf");
          _this.isPrint = false;
        });
        html2canvas();
      });
    }
  }
};
</script>

<style scope>
.d-block {
  display: block !important;
}

#event_control .btn {
  margin-bottom: 1rem;
  margin-right: 3rem;
}

@media (max-width: 426px) {
  .mobile-hide {
    display: none;
  }
  #event_control_user {
    padding: 2% 1% 0 10%;
  }
}

@media (min-width: 426px) {
  .mobile-show {
    display: none;
  }
  #event_control_user {
    padding: 20px 1% 0 0;
  }
}
</style>
